import { useState } from 'react';
import { Text } from 'react-native';
import { Tooltip } from 'react-native-elements';
import { Feather } from '@expo/vector-icons';
import { ADMIN_COLORS } from '../../config/theme/adminColors';

export const ControlledTooltip = (props) => {
  const [open, setOpen] = useState(false);
  return (
    <Tooltip
      visible={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      withOverlay={false}
      withPointer={true}
      backgroundColor="#666666"
      {...props}
    />
  );
};

export const TooltipCustom = ({ text, height, width, iconColor }) => {
  return (
    <ControlledTooltip
      popover={<Text style={{ color: '#fff' }}>{text}</Text>}
      containerStyle={{
        width: width ? width : 550,
        height: height ? height : 'auto',
      }}
    >
      <Feather
        name="info"
        size={15}
        color={iconColor || ADMIN_COLORS.muted}
        style={{ padding: 5 }}
      />
    </ControlledTooltip>
  );
};
